// Multiplayer server URL resolution priority:
//   1. ?mp=<url> query param ("1" → http://localhost:3001, "0"/"off" → disabled)
//   2. VITE_MP_SERVER build-time env (Vite inlines this at build)
//   3. window.RACING_MP_SERVER runtime override
//   4. localhost auto-detect (page on localhost ⇒ default to http://localhost:3001)
//   5. '' (multiplayer disabled)

function resolveServerUrl() {

	const param = new URLSearchParams( window.location.search ).get( 'mp' );
	if ( param !== null ) {

		if ( param === '0' || param === 'off' ) return '';
		if ( param === '1' ) return 'http://localhost:3001';
		return param;

	}

	if ( import.meta.env && import.meta.env.VITE_MP_SERVER ) {

		return import.meta.env.VITE_MP_SERVER;

	}

	if ( typeof window !== 'undefined' && window.RACING_MP_SERVER ) {

		return window.RACING_MP_SERVER;

	}

	if ( typeof window !== 'undefined' ) {

		const host = window.location.hostname;
		if ( host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0' ) {

			return 'http://localhost:3001';

		}

	}

	return '';

}

export const MP_SERVER_URL = resolveServerUrl();
